import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * Tailles de texte de l'échelle maison — celles déclarées dans
 * `tailwind.config.ts` sous `fontSize`. Cette liste doit rester alignée sur
 * elle : une taille ajoutée là et oubliée ici redeviendrait invisible.
 */
const FONT_SIZES = [
  'display-xl',
  'display-lg',
  'display-md',
  'display-sm',
  'heading-lg',
  'heading-md',
  'heading-sm',
  'body-lg',
  'caption',
]

/**
 * Fusionne des classes Tailwind en laissant la dernière gagner.
 * `cn('px-4', condition && 'px-6')` → `px-6` sans conflit résiduel.
 *
 * ─── Pourquoi une configuration, et pas `twMerge` nu ───
 *
 * `tailwind-merge` ne lit pas `tailwind.config.ts`. Il ne connaît donc ni nos
 * tailles (`text-heading-lg`) ni nos couleurs (`text-content-primary`), et
 * range TOUT ce qui commence par `text-` dans le même groupe « couleur ».
 * Deux classes du même groupe entrent en conflit : la dernière gagne.
 *
 * Résultat, `cn('font-display text-heading-lg text-content-primary')` rendait
 * `font-display text-content-primary` — **la taille était silencieusement
 * supprimée**. Tous les titres du site s'affichaient à la taille du texte
 * courant, sans erreur nulle part : ni le typage, ni le build, ni les
 * traductions ne peuvent voir ça passer. Seule une capture d'écran le montre.
 *
 * Déclarer les tailles ici les sort du groupe « couleur » : une taille et une
 * couleur cohabitent de nouveau sur le même élément.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: FONT_SIZES }],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
